import React, { useState, Fragment, useContext } from "react";
import Payement from "../../img/payement.jpg";
import Card from "../../components/Card";
import { Dialog, Transition } from "@headlessui/react";
import { HiXMark } from "react-icons/hi2";
import { DataContext } from "../../context/contextAPI"

function Products() {
  const { products, addCart, disabledButtons } = useContext(DataContext);

  let [isOpen, setIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);


  function open(product) {
    setSelectedProduct(product);
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  return (
    <>
      <div
        className="bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100"
      >
        <div className="px-5 md:px-8 lg:px-32 xl:px-40 2xl:px-60 py-8 md:py-12 lg:py-20">
          <h2 className="mt-14 md:mt-10 lg:mt-8 text-xl sm:text-2xl md:text-3xl lg:text-4xl poppins-bold uppercase text-center bg-pink-600 py-2 md:py-4 text-white">
            Nos produits en plastique recyclé
          </h2>
          <p className="py-4 xl:py-8 text-sm sm:text-base text-justify text-gray-500">
            ECOKAZ propose une gamme de produits étanches, durables et
            résistants, tout en restant compétitifs sur le marché. Nos produits
            incluent des tuiles en plastique, des briques Lego auto-fxantes en
            plastique, des carreaux, des pavés autobloquantes et des portes à
            rideaux. La durée de vie de nos produits peut dépasser les 50 ans.
            En choisissant ECOKAZ, vous réduisez les délais de construction et
            réalisez d'imprtantes économies, tout en minimisant l'utilisation de
            produits importés.
          </p>
          <ul className="text-gray-500 px-3 text-sm sm:text-base">
            <li className="list-disc">
              ECOKAZ propose des formations pour l'utilisation des materiaux
            </li>
            <li className="list-disc">
              ECOKAZ propose une garantie de 5 ans sur tous les matériaux de
              construction
            </li>
            <li className="list-disc">ECOKAZ offres des produits durables</li>
          </ul>

          <div className="grid grid-cols-1 min-[360px]:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 px-1 min-[280px]:px-3 min-[360px]:px-0 min-[480px]:px-0 gap-4 md:gap-3 lg:gap-5 mt-10 sm:mt-16">
            {
              products.map(product =>(
                <Card
                  key={product.id}
                  imgSrc={product.imgSrc}
                  imgAlt={product.imgAlt}
                  title={product.title}
                  description={product.mesure}
                  price={product.prix}
                  onClick={() => open(product)}
                  addCart={() => addCart(product._id)}
                  disabled={disabledButtons[product._id]}
                />
              ))
            }
          </div>
        </div>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50 w-96" onClose={close}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-200 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-200 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="max-w-full md:max-w-4xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all mx-2">
                  <Dialog.Title
                    as="h3"
                    className="flex justify-between items-center text-xl poppins-semibold leading-6 text-gray-900 border-b border-b-gray-600 px-5 py-4"
                  >
                    Description d'un produit
                    <HiXMark size={24} className="hover:bg-pink-200 hover:text-pink-600 transition-all duration-300 hover:scale-110 cursor-pointer rounded-full" onClick={close} />
                  </Dialog.Title>
                  <div className="mt-2">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8">
                      <div className="flex flex-col sm:flex-row -mx-4 i tems-center justify-center">
                          <div className="px-4 flex justify-center items-center">
                              <div className="rounded-lg">
                                  <img className="w-32 sm:w-52 lg:w-60 2xl:w-80 object-cover" src={selectedProduct?.imgSrc} alt={selectedProduct?.imgAlt} />
                              </div>
                          </div>
                          <div className="sm:flex-1 px-4">
                              <h2 className="text-lg sm:text-xl md:text-2xl poppins-bold text-pink-600 mb-1 sm:mb-2 uppercase text-center sm:text-start sm:mt-0 mt-3">
                                { selectedProduct?.descTitle }
                              </h2>
                              <p className="text-gray-600 poppins-semibold sm:text-lg mb-1 sm:mb-2 text-center sm:text-start">
                                { selectedProduct?.mesure }
                              </p>
                              <div className="flex mb-2 sm:mb-2 justify-center sm:justify-start">
                                  <div className="mr-0 sm:mr-4">
                                      <span className="poppins-semibold text-gray-600 sm:text-lg underline uppercase mr-1">Prix:</span>
                                      <span className="text-pink-600 sm:text-lg poppins-semibold">{ selectedProduct?.prix } MGA</span>
                                  </div>
                              </div>
                              <div className="mb-4">
                                <div className="flex sm:justify-start justify-center">
                                  <img src={Payement} alt="Payement" className="h-16 sm:h-20" />
                                </div>
                                <p className="text-pink-600 poppins-semibold text-center sm:text-start text-base sm:text-lg">Livraison gratuitement</p>
                              </div>
                              <div class="flex items-center justify-center sm:justify-start mt-2 mb-2">
                                <button
                                  type="button"
                                  className={`w-full sm:max-w-96 inline-flex justify-center rounded-md border border-transparent text-sm sm:text-base px-4 py-2 poppins-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-500 focus-visible:ring-offset-2 uppercase text-white ${disabledButtons[selectedProduct?._id] ? 'bg-gray-400 cursor-not-allowed hover:bg-gray-400 hover:text-white' : 'bg-black hover:bg-pink-200 hover:text-pink-600'}`}
                                  onClick={()=> addCart(selectedProduct?._id)}
                                  disabled={disabledButtons[selectedProduct?._id]}
                                >
                                  Ajouter au panier
                                </button>
                              </div>
                              <div>
                                  <h5 className="poppins-semibold text-gray-700 underline sm:text-lg text-center sm:text-start">Product Description:</h5>
                                  <p className="text-gray-600 text-xs sm:text-sm mt-2 poppins-regular text-center sm:text-start">
                                    { selectedProduct?.description }
                                  </p>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent bg-pink-100 px-4 py-3 poppins-bold text-pink-600 hover:bg-pink-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-500 focus-visible:ring-offset-2 uppercase"
                      onClick={close}
                    >
                      Fermer
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default Products;
